import { render } from "./GameTile.vue?vue&type=template&id=462e43fa&scoped=true"
import script from "./GameTile.vue?vue&type=script&lang=js"
export * from "./GameTile.vue?vue&type=script&lang=js"

import "./GameTile.vue?vue&type=style&index=0&id=462e43fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462e43fa"]])

export default __exports__